<modal-component>

	<!-- LEFT-->
	<ng-container left>

		<ng-container>
			<div class="_header">
				<p class="_title" [translate]="type === EventAttendanceType.Reservation ? 'CANCEL_RESERVATION.TITLE_RESERVATION' : 'CANCEL_RESERVATION.TITLE_REGISTRATION'">
				</p>
			</div>
	
			<!-- info or context -->

			<div class="_info" *ngIf="type === EventAttendanceType.Reservation || EventAttendanceType.Registration">
				<info-line icon="./assets/icons/calendar-outline.svg">
					<p>{{calendarEvent.Event?.name}} ({{calendarEvent.Event?.EventType?.name}})</p>
				</info-line>				
				<ng-container *ngIf="reservation?.startsAt && reservation?.endsAt">
					<info-line icon="./assets/icons/calendar-outline.svg">
						<p>{{reservation.startsAt | date:"EEEE d MMM yyyy"}} | {{reservation.startsAt | date:"HH:mm"}} - {{reservation.endsAt | date:"HH:mm"}}</p>
					</info-line>				
				</ng-container>

				<ng-container *ngIf="type === EventAttendanceType.Registration">
					<info-line icon="./assets/icons/calendar-outline.svg">
						<p>{{event?.startsAt | date:"EEEE d MMM yyyy"}} | {{event?.startsAt | date:"HH:mm"}} - {{event?.endsAt | date:"HH:mm"}}</p>
					</info-line>				
				</ng-container>

				<info-line icon="./assets/icons/attendance-type-outline.svg" align="top">
					<p><b [translate]="'EVENT.ATTENDANCE_TYPE_TITLE'"></b></p>
					<ng-container [ngSwitch]="type">
						<p *ngSwitchCase="EventAttendanceType.Reservation">{{'EVENT_ATTENDANCE_TYPE.RESERVATION' | translate}}</p>
						<p *ngSwitchCase="EventAttendanceType.Registration">{{'EVENT_ATTENDANCE_TYPE.REGISTRATION' | translate}}</p>
						<p *ngSwitchCase="EventAttendanceType.WalkIn">{{'EVENT_ATTENDANCE_TYPE.WALKIN' | translate}}</p>
						<p *ngSwitchCase="EventAttendanceType.Lessons">{{'EVENT_ATTENDANCE_TYPE.LESSONS' | translate}}</p>
					</ng-container>
				</info-line>

				<ng-container *ngIf="event?.locationType === EventLocationType.OnLocation">
					<info-line icon="./assets/icons/location-outline.svg" align="top">
						<p><b>{{event?.Location?.place}}</b></p>
						<p [navigate]="[InternalNavigationType.address, event?.Location?.Address]">{{event?.Location?.Address | address}}</p>
					</info-line>
				</ng-container>
					
				<ng-container *ngIf="event?.locationType === EventLocationType.Online">
					<info-line icon="./assets/icons/online-event-outline.svg" align="top">
						<p><b [translate]="'EVENT.IS_ONLINE_EVENT'"></b></p>
						<p class="_url" [navigate]="[InternalNavigationType.url, event?.url]">{{event?.url}}</p>
					</info-line>
				</ng-container>

				<info-line icon="./assets/icons/created-by-outline.svg" align="top" *ngIf="reservation?.CreatedBy?.email">
					<p><b><span>{{'EVENT.CREATED_BY' | translate}}: </span></b><span [navigate]="[InternalNavigationType.email, reservation.CreatedBy?.email]">{{reservation.CreatedBy?.email}}</span> 
						<span style="color: grey"> ({{reservation.createdAt | date:"EEEE d MMM yyyy"}})</span>
					</p>
				</info-line>
			</div>
		</ng-container>
		
	</ng-container>

	<!-- RIGHT -->
	<ng-container right>

		<!-- CREATE RESERVATION -->
		<ng-container>
			<!-- CLIENT DETAILS -->
			<div class="_client-details">
				<p class="_title" [translate]="'CLIENT.TITLE'"></p>
				<client-details-component [client]="reservation.Client"></client-details-component>
			</div>

			<form [formGroup]="cancelForm" *ngIf="cancelForm">	
				<form-select 
					label="{{ 'CANCEL_RESERVATION.CANCELLATION_REASON_ID' | translate }}" 
					[formControl]="cancelForm.get('CancellationReasonId') | cast" 
					[items]="cancellationReasons" 
					bindValue="id" 
					bindLabel="name" 
					[multiple]="false" 
					position="top" 
				>
				</form-select>

				<form-textarea label="{{ 'CANCEL_RESERVATION.CANCELLATION_REASON' | translate }}" [formControl]="cancelForm.get('cancellationInfo') | cast" ></form-textarea>
			</form>
		</ng-container>
		
	</ng-container>

	<!-- BUTTONS -->
	<ng-container buttons>
		
		<button type="button" class="_button _delete-button" [translate]="type === EventAttendanceType.Reservation ? 'RESERVATION.DELETE' : 'REGISTRATION.DELETE'" (click)="cancelReservation()"></button>
		<button class="_button _cancel-button" [translate]="'EVENT.CANCEL'" (click)="close()"></button>

	</ng-container>

</modal-component>